var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSub03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4284 32.143C28.5292 32.143 34.2856 26.3866 34.2856 19.2859C34.2856 12.1851 28.5292 6.42871 21.4284 6.42871C14.3276 6.42871 8.57129 12.1851 8.57129 19.2859C8.57129 26.3866 14.3276 32.143 21.4284 32.143Z",
    fill: "#FFCACF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 57.8573C0 46.0227 9.59391 36.4287 21.4286 36.4287C33.2632 36.4287 42.8571 46.0227 42.8571 57.8573C42.8571 59.0406 41.8977 60.0001 40.7143 60.0001H2.14286C0.959391 60.0001 0 59.0406 0 57.8573Z",
    fill: "#FFCACF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9036 60H57.8572C59.0405 60 60 59.0404 60 57.8571C60 46.0226 50.406 36.4286 38.5715 36.4286C38.2241 36.4286 37.8787 36.4369 37.5354 36.4532C44.0212 41.3416 48.2143 49.1096 48.2143 57.8571C48.2143 58.6016 48.1059 59.3211 47.9036 60ZM34.8525 31.5969C36.0298 31.9521 37.2783 32.143 38.5715 32.143C45.6725 32.143 51.4286 26.3866 51.4286 19.2859C51.4286 12.1851 45.6725 6.42871 38.5715 6.42871C37.2783 6.42871 36.0298 6.6196 34.8525 6.97475C37.8272 10.2166 39.6429 14.5392 39.6429 19.2859C39.6429 24.0325 37.8272 28.3551 34.8525 31.5969Z",
    fill: "#F84343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSub03);
export default __webpack_public_path__ + "static/media/sub_03.bd77c051fc242813cabc1a6f638a3faa.svg";
export { ForwardRef as ReactComponent };